import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { NavLink } from 'react-router';
import { toast } from 'react-toastify';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod/v4';

import { Button, TextInput } from '@engecomp/shared/components';
import { useUserContext } from '@engecomp/shared/contexts';
import { RPaths } from '@engecomp/shared/utils';

import LogoIcon from '@engecomp/shared/icons/logo.svg';

import styles from './index.module.css';

const form = z.object({
  email: z.string().email('E-mail inválido').min(1, { message: 'obrigatório' }),
  password: z.string().min(1, { message: 'obrigatório' }),
});

export type Form = z.infer<typeof form>;

export function Login() {
  const { login, token, userType } = useUserContext();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<Form>({ resolver: zodResolver(form) });

  async function onSubmit(props: Form) {
    try {
      await login(props);
    } catch (error) {
      console.error(error);
      toast.error('Erro ao fazer login');
    }
  }

  useEffect(() => {
    if (!userType || !token) return;

    if (userType === 'sysadmin') {
      window.location.href = RPaths.sysadmin.root;
    } else if (userType === 'manager') {
      window.location.href = RPaths.auth.chooseCompany;
    } else {
      window.location.href = RPaths.auth.chooseCompany;
    }
  }, [userType, token]);

  return (
    <div className={styles.LoginPage}>
      <img src={LogoIcon} alt='logo' />

      <header>Login</header>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit, (e) => {
            console.error(e);
            toast.error('Verifique os campos');
          })(e);
        }}
      >
        <TextInput field='email' type='email' label='Email' placeholder='E-mail' errors={errors} {...{ register }} />

        <TextInput
          field='password'
          type='password'
          label='Senha'
          placeholder='Insira sua senha'
          errors={errors}
          {...{ register }}
        />

        <Button type='submit'>Entrar</Button>
      </form>

      <NavLink to={RPaths.auth.forgotPassword}>Esqueceu a senha?</NavLink>
    </div>
  );
}
